module.exports = __webpack_public_path__ + "static/media/3.ff6ca466.jpg";